"use client";

import { useClientTranslations } from "@/lib/translate";
import { routes } from "@/lib/utils/routes";
import Link from "next/link";

export const BusinessHero = () => {
  const { t } = useClientTranslations("business-landing");

  return (
    <section className="relative overflow-hidden bg-white pt-24 pb-16 sm:pt-32 sm:pb-24">
      {/* Background decoration */}
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(45%_45%_at_50%_50%,var(--color-primary-lighter)_0%,white_100%)] opacity-20" />

      <div className="container mx-auto px-4">
        <div className="text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-gray-900 sm:text-6xl mb-6">
            <span className="block text-primary">{t("hero.title")}</span>
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-lg leading-8 text-gray-600">
            {t("hero.subtitle")}
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Link
              href={routes.auth.businessSignup}
              className="rounded-full bg-primary px-8 py-4 text-lg font-semibold text-white shadow-lg hover:bg-primaryLight focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary transition-all duration-300 hover:scale-105"
            >
              {t("hero.cta")}
            </Link>
          </div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute top-1/2 left-0 -translate-y-1/2 -z-10 translate-x-[-20%]">
        <div className="h-[400px] w-[400px] rounded-full bg-primary/5 blur-3xl" />
      </div>
      <div className="absolute top-1/2 right-0 -translate-y-1/2 -z-10 translate-x-[20%]">
        <div className="h-[400px] w-[400px] rounded-full bg-secondary/5 blur-3xl" />
      </div>
    </section>
  );
};

BusinessHero.displayName = "BusinessHero";
